module.exports = __webpack_public_path__ + "static/media/creditcardbenefits-1.a4a5a662.svg";